// @flow
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React from "react";
import { Trans } from "react-i18next";
import ContentLoader from "../../../../../components/general/contentLoader/contentLoader";
import CustomTranslation from "../../../../../components/general/customTranslation/customTranslation";
import { Permissions } from "../../../../../helpers/constants";
import { checkCatalogDisabled } from "../../../../../helpers/helpers";
import { EXHIBITION } from "../../../../../locales/components/namespaces";
import { useHasPermission } from "../../../../../modules/permission/hooks/useHasPermission";
import CatalogLogo from "../../../../profileExhibitor/partials/catalogLogo";

type Props = {}

const FreeAdvertisement = (props: Props) => {
	const { exhibitionId: id, loading, exhibitor, exhibition } = props
	const {
		catalogLocked,
		daysForCatalogSubmission,
		dateFrom,
		dateTo
	} = exhibition
	const isOrganizer = useHasPermission([Permissions.BeOrganizer], { shouldView: true })
	const {
		catalogDisabled
	} = checkCatalogDisabled({
		isOrganizer,
		openExhibitorCatalogue: exhibitor.openExhibitorCatalogue,
		catalogLocked,
		daysForCatalogSubmission,
		dateFrom,
		dateTo
	})
	return (
		<div>
			{exhibitor ? (
				<Box>
					<Paper sx={{ mb: 1, p: 1 }} variant={"outlined"}>
						<CustomTranslation
							code={'free_advertisement'}
							translations={exhibition?.translations}
						>
							<Typography component={"div"} variant={"body1"}>
								<Trans
									i18nKey={'free_advertisement_upload_info'}
									ns={EXHIBITION}
								>
									<strong>Free Catalogue Advertisement</strong><br/><br/>
									On this section you have the opportunity to include a full-page advertisement with
									your company's details free of charge.<br/><br/>
									Upload a <strong>single</strong> file.
									Only <strong>.jpg</strong>, <strong>.png</strong> and <strong>.pdf</strong> file
									extensions are allowed. Advertisement dimensions should be <strong>21 x
									29,7(A4)</strong> up to <strong>20Mb</strong>.<br/><br/>
									Free advertisements remain editable until the date on which the catalogue is closed.<br/><br/>
									<strong>Attention: The advertisements will follow the exhibition catalogue and will
										appear in random order. For this reason, it is essential that your company's
										details are provided.</strong>
								</Trans>
							</Typography>
						</CustomTranslation>
					</Paper>
					<CatalogLogo
						exhibitorId={exhibitor.id}
						exhibitionId={id}
						disabled={catalogDisabled}
					/>
				</Box>
			) : (
				<ContentLoader
					loading={loading}
				/>
			)}
		</div>
	);
};

export default FreeAdvertisement